export default __webpack_public_path__ + "static/media/labyrinthen-tenancy-03.8131d19d.jpg";